import ViewingToolShortcuts from '~/components/toolbar/steps/ViewingToolShortcuts';
import ToolGroup from '~/components/toolbar/shared/ToolGroup';
import BoxZoomTool from '~/components/toolbar/tools/BoxZoomTool';
import DvhTool from '~/components/toolbar/tools/DvhTool';
import IsolateTool from '~/components/toolbar/tools/IsolateTool';
import MeasureTool from '~/components/toolbar/tools/MeasureTool';
import WindowingHistogramTool from '~/components/toolbar/tools/WindowingHistogramTool';
import SeriesOverviewTool from '~/components/toolbar/tools/SeriesOverviewTool';
import PanTool from '~/components/toolbar/tools/PanTool';
import ResetViewTool from '~/components/toolbar/tools/ResetViewTool';
import RotateViewTool from '~/components/toolbar/tools/RotateViewTool';
import ScreenshotTool from '~/components/toolbar/tools/ScreenshotTool';

export default function DoseTools() {
    return (
        <>
            <ToolGroup>
                <PanTool />
                <BoxZoomTool />
                <RotateViewTool />
                <ResetViewTool />
                <WindowingHistogramTool />
                <SeriesOverviewTool />
                <MeasureTool allowRegions={false} />
                <IsolateTool />
                <ScreenshotTool />
            </ToolGroup>
            <ToolGroup>
                <DvhTool />
            </ToolGroup>
            <ViewingToolShortcuts />
        </>
    );
}
